<div class="bc-panel bc-layout-wrapper nanorep-panel" [ngClass]="{ 'knowledge-base-inline': !isExpanded }" [hidden]="!isOpened">
  <div class="knowledge-base-panel">
    <div class="knowledge-base-top-bar">
      <div class="knowledge-base-header-title">
        <svg-icon icon="smart-advisor"></svg-icon>
        <span>{{ 'nanorepPanel.panelTitle' | translate }}</span>
      </div>
      <svg-icon icon="x" (click)="closeNanorepPanel()" *ngIf="!isExpanded" class="icon-close"></svg-icon>
    </div>
    <div class="query-field-container"></div>
    <div *ngIf="visitorSearchQuery && answers.length > 0" class="suggested-title">{{ 'nanorepPanel.suggestedForVisitor' | translate }}</div>
    <div class="no-results-container" *ngIf="!hasSearchResult">{{ 'nanorepPanel.noResults' | translate }}</div>
    <div class="search-results-container" #answerContainer>
      <div [hidden]="!hasSearchResult">
        <nanorep-answer *ngFor="let answer of answers"
                        [config]="answer"
                        [focused]="answer.index === activeAnswerIndex"
                        (mouseenter)="answerFocused(answer.index)"
                        (articleClick)="answerSelected($event)"></nanorep-answer>
      </div>
    </div>
  </div>
</div>

